export function formatAmount(value: number, currency: string): string {
  return `${currency} ${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

// Nets are always explicitly signed: "+ USD 4,600.00" / "- USD 120.00"
export function formatSignedAmount(value: number, currency: string): string {
  const sign = value >= 0 ? '+' : '-';

  return `${sign} ${formatAmount(Math.abs(value), currency)}`;
}
